import { render, staticRenderFns } from "./globalConfig.vue?vue&type=template&id=6ffe08c8&scoped=true&"
import script from "./globalConfig.vue?vue&type=script&lang=js&"
export * from "./globalConfig.vue?vue&type=script&lang=js&"
import style0 from "./globalConfig.vue?vue&type=style&index=0&id=6ffe08c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe08c8",
  null
  
)

export default component.exports